export const colors = {
  white: {
    75: `#000000`,
  },
  yellow: {
    75: `#FEEB00`,
  },
};
